// «Zobacz w środku»: ONLY real pages from POLSKI GOTOWY™ Tom 1 (Gamma Estudio, pages 10, 11, 18, 27, 34). Empty = section hidden.
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/01060a17-12b5-462e-9c45-c87779a7c0e4/';
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [{
  src: BASE + '1792787848084_polski-gotowy-tom1-p10-lekcja-b5b7d15c.webp',
  label: 'Lekcja minuta po minucie',
  title: 'Mit o Prometeuszu – strona nauczyciela',
  text: 'Cel, materiały i przebieg 45 minut (0–5, 5–15, 15–35, 35–42, 42–45) z instrukcją i kluczem odpowiedzi.'
}, {
  src: BASE + '1792787859119_polski-gotowy-tom1-p11-karta-2e42a6ac.webp',
  label: 'Karta pracy w 3 poziomach',
  title: 'Mit o Prometeuszu – karta ucznia',
  text: 'Poziom 1, 2 i 3 na jednej kartce, do druku, z samooceną ucznia: łatwe · w sam raz · trudne.'
}, {
  src: BASE + '1792787864877_polski-gotowy-tom1-p18-lektura-db191149.webp',
  label: 'Karta do lektury',
  title: 'Chłopcy z Placu Broni – honor i przyjaźń',
  text: 'Gotowa lekcja do lektury w klasie 5: rozmowa, praca z tekstem, mapa myśli i klucz odpowiedzi.'
}, {
  src: BASE + '1792787871894_polski-gotowy-tom1-p27-gramatyka-e4c9d008.webp',
  label: 'Ćwiczenia z gramatyki',
  title: 'Zdanie pojedyncze i złożone',
  text: 'Trzy poziomy ćwiczeń: rozpoznawanie zdań, przecinki i łączenie zdań spójnikami.'
}, {
  src: BASE + '1792787876724_polski-gotowy-tom1-p34-sprawdzian-47c8f6f2.webp',
  label: 'Sprawdzian z kluczem',
  title: 'Sprawdzian po 12 lekcjach',
  text: '8 zadań, 20 punktów, 45 minut – gotowy do wydruku, z kluczem, punktacją i skalą ocen dla nauczyciela.'
}];
